module.exports = __webpack_public_path__ + "img/slide8.0d566cc9.png";